<script setup>
import { defineProps, computed } from "vue";

const props = defineProps({
  initials: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: "medium",
    validator: (value) => ["small", "medium", "large"].includes(value),
  },
});

const styles = computed(() => {
  let sizeStyles = {};
  switch (props.size) {
    case "small":
      sizeStyles = {
        width: "30px",
        height: "30px",
        fontSize: "0.9rem",
      };
      break;
    case "large":
      sizeStyles = {
        width: "6rem",
        height: "6rem",
        fontSize: "2.5rem",
      };
      break;
    case "medium":
    default:
      sizeStyles = {
        width: "50px",
        height: "50px",
        fontSize: "1.3rem",
      };
      break;
  }
  return sizeStyles;
});
</script>
<template>
  <div
    class="header-avatar"
    :style="{
      ...styles,
    }"
  >
    <p
      :style="{
        color: initials === 'GC' ? '#ccc' : 'rgb(245,245,245)',
        fontSize: styles.fontSize,
      }"
    >
      {{ initials }}
    </p>
  </div>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";

p {
  color: $white-color;
  font-weight: bold;
  font-size: 1.3rem;
  margin-bottom: 0;
  text-align: center;
  text-transform: uppercase;
}
</style>
